import { render } from "./bdWeiXin.vue?vue&type=template&id=695554c1&scoped=true"
import script from "./bdWeiXin.vue?vue&type=script&lang=js"
export * from "./bdWeiXin.vue?vue&type=script&lang=js"

import "./bdWeiXin.vue?vue&type=style&index=0&id=695554c1&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-695554c1"]])

export default __exports__